import {
  Button,
  Divider,
  Grid,
  Paper,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography
} from '@mui/material';
import { type Theme, useTheme } from '@mui/material/styles';
import { useRef, useState } from 'react';
import { Link as RouterLink } from 'react-router';
import { type Status } from '../../stores/common/pagination-query-params';
import type { ComboBoxDataItem } from '../../utils/transform-to-options';
import AppLinkButton from './AppLinkButon';
import ComboBox from './Combobox';

const getStyles = (theme: Theme) => ({
  card: {
    padding: theme.spacing(2)
  }
});

interface ListFilterProps {
  module: string;
  title: string;
  optionsFilter: ComboBoxDataItem[];
  canAdd: boolean;
  addUrl: string;
  showStatus?: boolean;
  defaultFilterColumn: string;
  defaultStatus?: Status;
  defaultFilterText: string;
  onFiltersChange: (event: FiltersChangeEvent) => void;
}

export interface FiltersChangeEvent {
  filterText: string;
  filterColumn: string;
  status: Status;
}

const ListFilter = ({
  module,
  title,
  optionsFilter,
  canAdd,
  addUrl,
  showStatus,
  defaultFilterColumn,
  defaultStatus,
  defaultFilterText,
  onFiltersChange
}: ListFilterProps) => {
  const theme = useTheme();
  const classes = getStyles(theme);
  const [filterText, setFilterText] = useState(defaultFilterText);
  const [filterColumn, setFilterColumn] = useState(defaultFilterColumn);
  const [status, setStatus] = useState(defaultStatus);

  const debounceTimeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleFilterTextChange = (value: string) => {
    setFilterText(value);
    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }
    debounceTimeout.current = setTimeout(() => {
      onFiltersChange({
        filterText: value,
        filterColumn,
        status
      });
    }, 500);
  };
  const handleFilterColumnChange = (value: string) => {
    setFilterColumn(value);
    onFiltersChange({
      filterText,
      filterColumn: value,
      status
    });
  };
  const handleStatusChange = (value: string) => {
    const status = value as Status;
    setStatus(status);
    onFiltersChange({
      filterText,
      filterColumn,
      status
    });
  };

  return (
    <Paper variant="outlined" sx={classes.card}>
      <Grid container direction="column" spacing={2}>
        <Grid>
          <Typography variant="h5">{title}</Typography>
        </Grid>
        <Divider />
        <Grid>
          <Grid container spacing={2}>
            <Grid size="grow">
              <TextField
                label="Filtro"
                placeholder="Filtrar por..."
                fullWidth
                value={filterText}
                onChange={(event) => handleFilterTextChange(event.target.value)}
              />
            </Grid>
            <Grid size={2}>
              <ComboBox
                label="Columna"
                value={filterColumn}
                onChange={(event) => handleFilterColumnChange(event.target.value)}
                options={optionsFilter}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid>
          <Grid container spacing={2} alignItems="center">
            {showStatus === true ? (
              <>
                <Grid>
                  <Typography>Status</Typography>
                </Grid>
                <Grid>
                  <ToggleButtonGroup
                    exclusive
                    value={status}
                    color="primary"
                    onChange={(_, value) => handleStatusChange(value)}
                  >
                    <ToggleButton value="activos">Activos</ToggleButton>
                    <ToggleButton value="inactivos">Inactivos</ToggleButton>
                    <ToggleButton value="todos">Todos</ToggleButton>
                  </ToggleButtonGroup>
                </Grid>
              </>
            ) : (
              <></>
            )}
            <Grid size="grow"></Grid>
            {canAdd ? (
              <Grid>
                <AppLinkButton
                  module={module}
                  permission="agregar"
                  variant="contained"
                  color="secondary"
                  disableElevation
                  // component={RouterLink}
                  to={addUrl}
                >
                  Nuevo
                </AppLinkButton>
              </Grid>
            ) : (
              <></>
            )}
            <Grid>
              <Button variant="contained" disableElevation component={RouterLink} to="/">
                Salir
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ListFilter;
